type IconProps = {
  className?: string
}

export default function LocationMarkerIcon({className = ''}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M12 2.25c-4.28 0-7.75 3.47-7.75 7.75 0 5.12 6.66 11.18 7.01 11.5a.75.75 0 0 0 .98 0c.35-.32 7.01-6.38 7.01-11.5 0-4.28-3.47-7.75-7.75-7.75Zm0 10.5a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
